export const HOME_EXPLORE_TUTORIAL_TOTAL_STEPS = 3;
